declare global {
  interface Window {
    ym?: (...args: unknown[]) => void;
    ymID?: number;
    yaCounter?: { reachGoal: (event: string, data?: Record<string, unknown>) => void };
  }
}

const METRIKA_SCRIPT = 'https://mc.yandex.ru/metrika/tag.js';
let metrikaInitialized = false;

function ensureYmStub(): void {
  if (window.ym) {
    return;
  }

  const stub = Object.assign((...args: unknown[]) => {
    stub.a.push(args);
  }, { a: [] as unknown[][], l: Date.now() });
  window.ym = stub;

  function insertScript() {
    const { scripts } = document;
    for (let j = 0; j < scripts.length; j += 1) {
      if (scripts[j].src === METRIKA_SCRIPT) {
        return;
      }
    }
    const script = document.createElement('script');
    const firstScript = document.getElementsByTagName('script')[0];
    script.async = true;
    script.src = METRIKA_SCRIPT;
    firstScript.parentNode?.insertBefore(script, firstScript);
  }

  if (document.readyState === 'complete') {
    setTimeout(insertScript, 0);
  } else {
    window.addEventListener('load', () => {
      setTimeout(insertScript, 0);
    });
  }
}

export function initYaMetrika(): void {
  if (metrikaInitialized || !window.ymID) {
    return;
  }

  metrikaInitialized = true;
  ensureYmStub();
  window.ym!(window.ymID, 'init', {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
  });
}

export function reachGoalYaMetrika(event: string, data?: Record<string, unknown>): void {
  if (window.yaCounter) {
    window.yaCounter.reachGoal(event, data);
  }
  if (window.ym && window.ymID) {
    window.ym(window.ymID, 'reachGoal', event, data);
  }
}
